















































































































import axios from "axios";
import { SchemaMock } from "json-schema-mock";
import { Component, Provide, Vue } from "vue-property-decorator";

@Component({
  name: "HomeLayout",
  components: {},
})
export default class extends Vue {
  beforeMount() {
    document.onkeydown = this.mockKeyUp;

    axios.get("examples.json").then(
      (res) => {
        this.examples = res.data.properties;
        // console.log(this.examples);
        this.randonSchema();
      },
      (err) => {}
    );
  }

  @Provide() examples: { [key: string]: any } = {};

  @Provide() inputSchema: string = "{}";
  @Provide() outputData: string = "{}";

  get inputEditor() {
    return this.$refs.inputEditor as any;
  }

  @Provide() lastMockSchemaStr: string = "{}";
  @Provide() lastMockSchemaMock?: SchemaMock;
  @Provide() firstMockDelay: string = "";
  @Provide() mockDelay: string = "";
  @Provide() repeat: number = 10;
  @Provide() analysisSchema: string = "";
  @Provide() showAnalysisSchema: boolean = false;

  mockBtn_click(event: MouseEvent) {
    this.showAnalysisSchema = event.ctrlKey;
    this.doMock();
  }

  mockKeyUp(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === "Enter") {
      this.doMock();
    } else if (event.altKey && event.key === "Enter") {
      this.randonSchema();
    }
  }

  doMock(schema?: string) {
    schema = schema ?? this.inputSchema;
    try {
      const schemaObj = JSON.parse(schema!);
      const schemaStr = JSON.stringify(schemaObj, null, 2);

      const pos = this.inputEditor.selectionStart;
      this.inputSchema = schemaStr;
      this.$nextTick(() => {
        this.inputEditor.focus();
        this.inputEditor.selectionStart = pos;
        this.inputEditor.setSelectionRange(pos, pos);
      });
      if (
        this.lastMockSchemaStr === schemaStr &&
        this.lastMockSchemaMock !== undefined
      ) {
        this.shemaMock();
      } else {
        this.firstMockDelay = "";
        SchemaMock.parser(schemaObj).then((re) => {
          this.lastMockSchemaStr = schemaStr;
          this.lastMockSchemaMock = re;
          this.shemaMock();
        });
      }
    } catch (err) {
      this.outputData = err.message;
      console.error(schema);
      console.error(err);
    }
  }

  shemaMock() {
    try {
      const start = Date.now();
      const datas: any[] = [];
      for (let i = 1; i <= this.repeat; i++) {
        datas.push(this.lastMockSchemaMock!.mock());
      }
      this.mockDelay = `${Date.now() - start}ms`;
      this.firstMockDelay = this.firstMockDelay || this.mockDelay;

      let strArr: string[] = [];
      for (let i = 0; i < datas.length; i++) {
        strArr.push(`// # ${i + 1}\n${JSON.stringify(datas[i], null, 2)}`);
      }
      this.outputData = strArr.join("\n\n");
      this.analysisSchema = JSON.stringify(
        this.lastMockSchemaMock!.analysisSchema,
        null,
        2
      );
    } catch (err) {
      this.outputData = err.toString();
      this.mockDelay = "ERROR";
    }
  }

  setInputSchema(schema: any) {
    for (let iKey in schema) {
      if (iKey.startsWith("x-mock")) delete schema[iKey];
    }
    this.doMock(JSON.stringify(schema));
  }

  randonSchema() {
    function pick(obj: any) {
      const iKeys = Object.keys(obj);
      let iIdx = Math.floor(Math.random() * iKeys.length);
      return obj[iKeys[iIdx]];
    }

    let iObj = pick(this.examples);
    console.log(iObj);
    let jObj = pick(iObj.properties);
    this.setInputSchema(jObj);
  }
}
